import React, { useContext, useState } from 'react';
import Label_language from "../../language";
import Main_layout from '../Main_layout'
import { ConfigProvider, Tooltip, Upload, Button as AntdButton, Row as AntRow, Col as AntCol, Layout } from 'antd';
import { Button, Card, Row } from 'react-bootstrap';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import styled from 'styled-components';
const label_language = Label_language.oms.children.online_order_management
const { ConfigContext } = ConfigProvider;
const Upload_style = styled(Upload)`
& .upload-list-inline .ant-upload-list-item {
  float: left;
  width: 200px;
  margin-inline-end: 8px;
}

& .ant-upload-rtl.upload-list-inline .ant-upload-list-item {
  float: right;
}
`
const App = () => {
  const configContext = useContext(ConfigContext);
  const language = configContext.locale.locale
  return (
    <Layout
      style={{
        minHeight: '100vh',

      }}
    >
      <Upload_ot
        language={label_language}
      />
    </Layout>
  );
}
export default App;
const Upload_ot = ({

}) => {
  const [file_list, set_file_list] = useState([])
  return (<>
    <Card>
      <Card.Body>
        <Card className="my-1 align-top" style={{ padding: '0rem', borderColor: "#6e6e6e" }}>
          <Card.Header
            className="justify-content-center align-items-center"
            style={{ borderColor: "#677696", background: "#EDFDF9", }}
          >
            <span style={{ color: "black", fontSize: '1.2rem' }}>{'手機上傳圖片'}</span>
          </Card.Header>
          <Card.Body style={{ height: '762px', overflowY: 'scroll' }}>
            <AntRow gutter={[24, 24]}>
              <AntCol span={24}>
                <Upload
                  listType="picture"
                  customRequest={e => {
                    let payload = new FormData();
                    payload.append('inputFile', e.file);
                    payload.append('token', 'mercy');
                    axios
                      .post("/media/api/file/upload_phone", payload, {
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        },
                      })
                      .then(response => {
                        e.onSuccess({
                          ...e.file,
                          status: 'success'
                        })
                        // set_file_list(prev=>prev.map(map_item=>(
                        //   map_item.uid===e.file.uid?
                        //   {
                        //     ...map_item,
                        //     status:'success'
                        //   }
                        //   :map_item
                        // )))
                      })
                  }}
                >
                  <Tooltip
                    title={'請由此開始進行操作'}
                    placement={'right'}
                  >
                    <AntdButton type={'primary'}>
                      <UploadOutlined style={{ textAlign: 'text-top' }} />
                      點此上傳圖片
                    </AntdButton>
                  </Tooltip>
                </Upload>
              </AntCol>
            </AntRow>
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  </>)
}